{Optimize} = window
{config} = Optimize.suiteData
config.finch = config: Optimize.finchConfig
OptimizeSuite.init Optimize.config = config
